/**
 * @file Join code related utilities.
 */

import uuidv4 from './uuid';

/**
 * Sanitizes a join code by removing all spaces
 * and allowing only a-z A-Z 0-9 - _.
 *
 * @param {string} joinCode - The join code.
 * @returns {string} - The sanitized join code.
 */
const sanitizeJoinCode = joinCode => {
  return joinCode.replace(/[^A-Z0-9-_]/gi, '').toLowerCase();
};

const isHumanJoinCode = joinCode => {
  return !!joinCode && !joinCode.toLowerCase().startsWith('rc-');
};

/**
 * Generates a random "machine" join code.
 * "Machine" join codes are just strings prefixed with `rc-`, which
 * makes them invisible by comms and platform (by convention).
 *
 * @param {number} [length=30] The desired length of the join code.
 * @returns {string}
 */
const generateMachineJoinCode = (length = 30) => {
  return `rc-${uuidv4()
    .replace(/-/g, '')
    .slice(0, length - 3)}`;
};

export { sanitizeJoinCode, isHumanJoinCode, generateMachineJoinCode };
